import { useEffect, useState } from 'react';
import {
  Button, Link, Grid2 as Grid, Typography, IconButton
} from '@mui/material';
import PinInput from 'react-pin-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

import { checkCode } from '../../actions/users';
import Alert from '../layout/Alerta';

const Step3 = ({ setAlert, addUser, navigate, data }) => {

  const [verificacion, setVeri] = useState('');
  const [disable, setDisable] = useState(true);
  const [disableSMS, setDisableSMS] = useState(false);

  useEffect(() => {
    setDisable(verificacion.length !== 4);
  }, [verificacion]);

  const reenviar = () => {
    sendCode(tel, '');
    setDisableSMS(true);
    setTimeout(() => {
      setDisableSMS(false)
    }, 18000);
  }

  const guardar = async e => {
    e.preventDefault();
    setDisable(true);

    const dbInfo = {
      name: data.infoUser.username,
      email: data.infoUser.email,
      tel: data.infoUser.tel,
      password: data.infoUser.pass
    };

    if (data.emailTel === "celular") {
      const info = {
        phonenumber: data.to,
        code: verificacion,
      }
      setDisable(true);
      const res = await checkCode(info, navigate, true);

      if (res.valid) {
        addUser(dbInfo, navigate);
      } else {
        setDisable(false);
        setAlert("Código incorrecto");
      }
    } else {
      const info = {
        email: data.infoUser.email,
        code: verificacion,
      }
      setDisable(true);
      const res = await checkCode(info, true);

      if (res.status === 'approved' && res.valid) {
        addUser(dbInfo, navigate);
      } else {
        setDisable(false);
        setAlert(res.msg ? res.msg : "Código incorrecto");
      }
    }
  }

  return (
    <Grid className="form-steps" size={{ lg: 6 }}>
      <form noValidate onSubmit={guardar}>
        <IconButton
          className="btn-icon"
          aria-label="back"
          onClick={() => navigate(-1)}
        >
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="h3" component="h3">Código</Typography>
        <Typography component="p">Introduce el código recibido.</Typography>
        <PinInput
          length={4}
          onChange={(value) => setVeri(value)}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={disable}
          sx={{ marginTop: 5, marginBottom: 3 }}
        >
          Verificar
        </Button>
        <Alert />
        <Typography className="link" component="p">
          Enviar nuevamente
          <Link component="button" underline='hover' disabled={disableSMS} onClick={() => reenviar()}> - SMS </Link>
        </Typography>

        <Typography className="link" component="p">
          ¿No puedes acceder?
          <Link href="#" underline='none'> - ayuda en línea</Link>
        </Typography>
      </form>
    </Grid>
  );
}

Step3.propTypes = {
  setAlert: PropTypes.func.isRequired,
  addUser: PropTypes.func.isRequired
}

export default Step3;